import { defineStore } from "pinia";
import Api from "@/utils/api/triggerSettings";

export const useTriggerSettingsStore = defineStore("trigger_settings_store", {
  persist: true,
  state: () => ({
    triggerSettings: [],
    allTriggerSettings: [],
    totalTriggerSettings: 0
  }),
  actions: {
    async fetchTriggerSettings(formId) {
      const response = await Api.getTriggerSettings(formId);
      this.triggerSettings = response.data || [];
      return this.triggerSettings;
    },

    async fetchAllTriggerSettings(config) {
      const response = await Api.getAllTriggerSettings(config);
      this.allTriggerSettings = response.data || [];
      this.totalTriggerSettings = response.total || 0;
      return response;
    },

    async updateTrigger(data) {
      const response = await Api.updateTriggerSetting(data);
      if (response.data) {
        const index = this.allTriggerSettings.findIndex(
          (t) => t.id === data.id
        );
        if (index !== -1) {
          this.allTriggerSettings[index] = {
            ...this.allTriggerSettings[index],
            ...response.data
          };
        }
      }
      return response;
    },

    async createTrigger(data) {
      const response = await Api.createTriggerSetting(data);
      if (response.data) {
        this.allTriggerSettings.push({ ...response.data });
      }
      return response;
    },

    async deleteTrigger(id) {
      const response = await Api.deleteTriggerSetting(id);

      if (response.success) {
        const index = this.allTriggerSettings.findIndex(
          (item) => item.id === id
        );
        if (index !== -1) {
          this.allTriggerSettings.splice(index, 1);
          this.totalTriggerSettings--;
        }
      }

      return response;
    }
  }
});
